<script setup lang="ts">
import type { SubMenuItem } from '~/components/menu/MenuTypes';

const props = defineProps<{
  icon: string[],
  title: string,
  children?: SubMenuItem[],
  url?: string,
  show?: boolean,
  isSelected?: boolean,
  clickFunc?:() => void,
  iconClass?: string,
  ariaLabel?: string,
}>();

const topLevelMenuColor = computed(() => {
  if (props.isSelected || (props.show && props.show === true)) {
    return 'text-primary-600 bg-white rounded-lg ';
  }

  return 'text-primary-200 ';
});
const btnClass = computed(() => {
  const baseClass = 'cursor-pointer block w-full rounded-lg py-3 px-2 text-left';
  if (props.isSelected || (props.show && props.show === true)) {
    return baseClass;
  }

  return `${baseClass} hover:bg-primary-100 hover:text-primary-700 hover:duration-100 hover:opacity-70`;
});
</script>

<template>
  <div
    class="top-level-menu"
    :class="topLevelMenuColor"
  >
    <NuxtLink
      v-if="url"
      :to="url"
      :class="btnClass"
      :aria-label="props.ariaLabel || props.title"
    >
      <UiFaIcon :icon="icon" :size="'2xl'" :class="iconClass" /> <span class="text-lg ml-4">{{ title }}</span>
    </NuxtLink>
    <button
      v-else
      :class="btnClass"
      tabindex="0"
      :aria-label="props.ariaLabel || props.title"
      data-cy="top-level-menu-item"
      type="button"
      @click="clickFunc?.()"
    >
      <UiFaIcon :icon="icon" :size="'2xl'" :class="iconClass" />
      <span class="text-lg ml-4">
        {{ title }}
      </span>
    </button>
    <div v-if="show" class="pl-6 pb-3 text-inactive text-sm">
      <slot />
    </div>
  </div>
</template>
